import React from 'react';
import classNames from 'classnames';
import BackgroundImageWrapper from '@/components/wrappers/background-image-wrapper';
import { compose } from '@/utils/story-composer';

function AbsoluteContainer({
	backgroundImage,
	pageContext,
	content,
	width,
	height,
	top,
	right,
	bottom,
	left,
	mobileTop,
	mobileRight,
	mobileBottom,
	mobileLeft,
}) {
	const baseTop = mobileTop || top;
	const baseRight = mobileRight || right;
	const baseBottom = mobileBottom || bottom;
	const baseLeft = mobileLeft || left;

	const topSm = baseTop !== top ? top : undefined;
	const rightSm = baseRight !== right ? right : undefined;
	const bottomSm = baseBottom !== bottom ? bottom : undefined;
	const leftSm = baseLeft !== left ? left : undefined;

	const style = {
		width: width ? `${width}rem` : undefined,
		height: height ? `${height}rem` : undefined,
		...(baseTop ? { '--absolute-container-top-base': `${baseTop}rem` } : {}),
		...(baseRight ? { '--absolute-container-right-base': `${baseRight}rem` } : {}),
		...(baseBottom ? { '--absolute-container-bottom-base': `${baseBottom}rem` } : {}),
		...(baseLeft ? { '--absolute-container-left-base': `${baseLeft}rem` } : {}),
		...(topSm ? { '--absolute-container-top-sm': `${topSm}rem` } : {}),
		...(rightSm ? { '--absolute-container-right-sm': `${rightSm}rem` } : {}),
		...(bottomSm ? { '--absolute-container-bottom-sm': `${bottomSm}rem` } : {}),
		...(leftSm ? { '--absolute-container-left-sm': `${leftSm}rem` } : {}),
	};

	return (
		<div className="relative">
			<div
				style={style}
				className={classNames(
					'absolute',
					baseTop ? 'top-[var(--absolute-container-top-base)]' : '',
					baseRight ? 'right-[var(--absolute-container-right-base)]' : '',
					baseBottom ? 'bottom-[var(--absolute-container-bottom-base)]' : '',
					baseLeft ? 'left-[var(--absolute-container-left-base)]' : '',
					topSm ? 'sm:top-[var(--absolute-container-top-sm)]' : '',
					rightSm ? 'sm:right-[var(--absolute-container-right-sm)]' : '',
					bottomSm ? 'sm:bottom-[var(--absolute-container-bottom-sm)]' : '',
					leftSm ? 'sm:left-[var(--absolute-container-left-sm)]' : ''
				)}
			>
				<BackgroundImageWrapper
					backgroundImage={backgroundImage}
					pageContext={pageContext}
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						backgroundSize: 'contain',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
					}}
				>
					{content}
				</BackgroundImageWrapper>
			</div>
		</div>
	);
}

export default AbsoluteContainer;

compose('absolute-container', AbsoluteContainer, { children: ['content'] });
